/* Built In Imports */
/* External Imports */
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import { Box, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import dynamic from 'next/dynamic';
/* Internal Imports */
/* Components */
const Header = dynamic(() => import(`@app-ps/Components/Header/index`));

/**
 * Renders the Top Banner Video component
 *
 * @param {object} sectionData - content from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} - Top Banner Video Component
 */
const TopBannerVideo = ({
  sectionContent,
  headerMenuData,
  pageData,
  region,
  language,
}) => {
  return (
    <>
      {/* <Box pos="absolute" top="0" w="100%" left="0" right="0" zIndex={1000}>
        <Header
          headerMenuData={headerMenuData}
          availableLocals={pageData && pageData.availableLocales}
          region={region}
          theme="light"
          language={language}
          languageAlsoin={pageData?.alsoin}
          pageUrl={pageData?.url}
        />
      </Box> */}
      <Box
        overflow="hidden"
        // border={{
        //   base: '2px solid green',
        //   sm: '2px solid yellow',
        //   md: '2px solid red',
        //   lg: '2px solid blue',
        // }}
        backgroundImage={{
          base: sectionContent?.mobileImage?.url,
          md: sectionContent?.image?.url,
        }}
        w="100%"
        minHeight={{
          base: '670px',
          md: '100vh',
          // lg: '110vh',
          // xl: '115vh',
          lg: '115vh',
          '2xl': '100vh',
        }}
        position="relative"
        paddingBottom="2rem"
        textAlign="center"
        backgroundSize={{ base: 'cover', md: 'cover 100%' }} // Ensures the full background is shown
        backgroundPosition={{ base: 'center', md: 'bottom' }} // Ensures proper alignment
        backgroundColor="#000"
        display="flex"
        justifyContent="center"
        alignItems={{ md: 'center', base: 'flex-end' }}
        flexDir="column"
        backgroundRepeat="no-repeat"
        _before={{
          content: '""',
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: { base: 0, md: '50%' }, // Start gradient at md
          background: {
            base: 'none', // No gradient for smaller screens
            md: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.45) 23%, rgba(0, 0, 0, 0.9) 100%)',
          },
          pointerEvents: 'none',
        }}
      >
        <Box
          position="absolute"
          // top={{ base: '70%', md: 'auto' }} // Adjust top position for smaller screens
          bottom={{ base: '14%', md: '15%', '2xl': '11%' }}
          mx={{ lg: '29.5625rem' }}
          w="full"
          textAlign="center"
        >
          <Box
            color="#FEFAF6"
            display="flex"
            // gap={{ '2xl': '1.5rem', base: '0' }}

            // border="2px solid red"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              fontWeight="400"
              mb={{
                base: '-0.5rem',
                lg: '-1.5rem',
                '2xl': '-0.5rem',
              }}
              fontSize={{ base: '1.75rem', md: '2.75rem', lg: '84px' }}
              lineHeight={{ base: '2.8rem', md: '3.3rem', lg: '105px' }}
              letterSpacing="0.16px"
              fontFamily="var(--FedraSerifDisplay-Regular)"
            >
              {sectionContent?.title?.split(' ')[0]}
            </Text>
            <Text
              fontWeight="700"
              fontSize={{
                base: '2.75rem',
                md: '3.75rem',
                lg: '100px',
                '2xl': '124px',
              }}
              fontFamily="var(--FedraSerifDisplay)"
              lineHeight={{ base: '3.25rem', md: '4.5rem', lg: '125px' }}
              letterSpacing="1%"
            >
              {sectionContent?.title?.split(' ').slice(1).join(' ')}
            </Text>
          </Box>
          <Box
            as="h4"
            fontFamily="var(--FedraSansStd-book)"
            mt={{ base: '0', md: '0', '2xl': '1rem' }}
            whiteSpace={'nowrap'}
            textAlign={'center'}
          >
            <StructuredTextParser
              str={render(sectionContent?.subtext)}
              fontSize={{ base: '1rem', lg: '1.5rem' }}
              fontWeight="400"
              color="#FEFAF6"
              textAlign="center"
              mt="0"
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default TopBannerVideo;
